const NoDataMsg = ({
  icon,
  title,
  subtitle = "",
  backgroundColor = "#fdfdff00",
  buttons = null,
  border = true
}) => {
  return (
    <div className="d-flex justify-content-center align-items-center py-0">
      <div
        className="text-center pb-4 px-4 cardNoData"
        style={{
          width: "100%",
          borderRadius: "16px",
          backgroundColor: backgroundColor,
          border: border ? "1px dashed #d6dbff" : "none",
        }}
      >
        <div
          className="mb-1"
          style={{
            fontSize: "56px",
            color: "#d9ebffff"
          }}
        >
          {icon}
        </div>

        <h6 className="fw-bold">{title}</h6>

        {subtitle && (
          <p className="text-muted mt-2 mb-0">{subtitle}</p>
        )}

        {buttons && buttons.length > 0 && (
          <div className="mt-3 d-flex justify-content-center gap-2 flex-wrap">
            {buttons.map((btn, i) => (
              <div key={i}>{btn}</div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NoDataMsg;